<template>
  <v-container grid-list-md fluid class="pa-0">
    <v-layout row wrap>
      <v-flex xs12>
        <v-tabs v-model="tab"
        background-color="primary" dark
        grow height="40"
        >
        <v-tab v-for="(tabitem, n) in tabitems" :key="n" :href="`#tab-${n}`" @change="refreshTab(tabitem)">
          {{ tabitem }}
        </v-tab>
      </v-tabs>
      <v-tabs-items v-if="lAction === 'view'" v-model="tab">
        <v-tab-item v-for="(tabitem, n) in tabitems" :key="n" :value="`tab-${n}`">

          <!-- Uniform Category -->
          <v-layout v-if="tab === 'tab-0'" class="pa-0" row wrap>
            <v-flex xs10 mx-auto>
              <v-flex xs12>
                <v-card flat>
                  <v-card-text class="pa-2">
                    <v-data-table
                    :headers="uniformCatHeader"
                    :items="uniformCat"
                    hide-default-footer
                    class="elevation-3"
                    dense
                    :mobile-breakpoint="0"
                    disable-pagination
                    >
                    <template slot="item" slot-scope="props">
                      <tr>
                        <td> {{ props.item.uniform_cat ? props.item.uniform_cat : '-' }} </td>
                        <td @click="prepareUpdateUniformCat(props.item)">
                          <v-btn icon class="mr-0">
                            <v-icon small>mdi-pencil</v-icon>
                          </v-btn>
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-flex>
        </v-layout>

        <!-- Uniform Sub Category -->
        <v-layout v-if="tab === 'tab-1'" class="pa-0" row wrap>
          <v-flex xs10 mx-auto>
            <v-flex xs12>
              <v-card flat>
                <v-card-text class="pa-2">
                  <v-data-table
                  :headers="uniformSubCatHeader"
                  :items="uniformSubCat"
                  hide-default-footer
                  class="elevation-3"
                  dense
                  :mobile-breakpoint="0"
                  disable-pagination
                  >
                  <template slot="item" slot-scope="props">
                    <tr>
                      <td> {{ props.item.uniform_sub_cat ? props.item.uniform_sub_cat : '-' }} </td>
                      <td @click="prepareUpdateUniformSubCat(props.item)">
                        <v-btn icon class="mr-0">
                          <v-icon small>mdi-pencil</v-icon>
                        </v-btn>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-flex>
      </v-layout>

      <!-- Uniform Category & Sub Category Mapping -->
      <v-layout v-if="tab === 'tab-2'" class="pa-0" row wrap>
        <v-flex xs11 mx-auto>
          <v-flex xs12>
            <v-card flat>
              <v-card-text class="pa-2">
                <v-data-table
                :headers="uniformCatSubCatMapHeader"
                :items="uniformCatSubCatMap"
                hide-default-footer
                class="elevation-3"
                dense
                :mobile-breakpoint="0"
                disable-pagination
                >
                <template slot="item" slot-scope="props">
                  <tr>
                    <td> {{ props.item.uniform_cat ? props.item.uniform_cat : '-' }} </td>
                    <td> {{ props.item.uniform_sub_cat ? props.item.uniform_sub_cat : '-' }} </td>
                    <td @click="prepareUpdateUniformCatSubCatMap(props.item)">
                      <v-btn icon class="mr-0">
                        <v-icon small>mdi-pencil</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-flex>
    </v-layout>

    <!-- Uniform Sub Category & Size Mapping -->
    <v-layout v-if="tab === 'tab-3'" class="pa-0" row wrap>
      <v-flex xs11 mx-auto>
        <v-flex xs12>
          <v-card flat>
            <v-card-text class="pa-2">
              <v-data-table
              :headers="uniformSubCatSizeMapHeader"
              :items="uniformSubCatSizeMap"
              hide-default-footer
              class="elevation-3"
              dense
              :mobile-breakpoint="0"
              disable-pagination
              >
              <template slot="item" slot-scope="props">
                <tr>
                  <td> {{ props.item.uniform_sub_cat ? props.item.uniform_sub_cat : '-' }} </td>
                  <td> {{ props.item.uniform_size ? props.item.uniform_size : '-' }} </td>
                  <td @click="prepareUpdateUniformSubCatSizeMap(props.item)">
                    <v-btn icon class="mr-0">
                      <v-icon small>mdi-pencil</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-flex>
  </v-layout>

</v-tab-item>
<v-tooltip top>
  <template v-slot:activator="{ on }">
    <v-btn v-if="lAction === 'view' && (config.IS_EDITED_BY_USER)" v-on="on"
    :style="'position:fixed; ' + ($vuetify.breakpoint.smAndDown?'bottom:15px; right:15px;':'bottom:15px; right:15px;')"
    dark fab fixed
    color="accent white--text"
    @click.native="tab === 'tab-0' ? prepareUniformCat() : tab === 'tab-1' ? prepareUniformSubCat() : tab === 'tab-2' ? prepareUniformCatSubCatMap() : prepareUniformSubCatSizeMap()">
    <v-icon>mdi-plus</v-icon>
  </v-btn>
</template>
<span v-if="tab === 'tab-0'" class="caption">Add Category</span>
<span v-else-if="tab === 'tab-1'" class="caption">Add Sub Category</span>
<span v-else-if="tab === 'tab-2'" class="caption">Add Category &amp; Sub Category Mapping</span>
<span v-else class="caption">Add Sub Category &amp; Size Mapping</span>
</v-tooltip>
</v-tabs-items>

<!-- Insert, Update and Delete Uniform Category -->
<v-container v-if="tab === 'tab-0' && (lAction === 'create' || lAction === 'update')" class="pa-2" grid-list-md>
  <v-layout row wrap>
    <v-flex xs8 mx-auto>
      <v-form ref="lFormUniformCat" @submit.prevent="saveCatChanges(lAction)">
        <v-card>
          <v-card-title class="py-3 title">
            {{ handy.startWithUpper(lAction) }} Uniform Category
          </v-card-title>
          <v-card-text class="px-2 pb-2 pt-0">
            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field
                v-model="lUniformCat.uniform_cat"
                label="Uniform Category"
                :rules="[rules.required]"
                hide-details
                maxlength="100"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions class="pt-3">
            <v-layout row wrap>
              <v-spacer></v-spacer>
              <v-btn @click.stop="cancelChanges()">Cancel</v-btn>
              <v-btn v-if="lAction === 'update' && (config.IS_EDITED_BY_USER)" @click="deleteUniformCat(lUniformCat)">delete</v-btn>
              <v-btn type="submit" color="accent black--text" v-if="(config.IS_EDITED_BY_USER)" :disabled="beingSaved">Save</v-btn>
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-flex>
  </v-layout>
</v-container>

<!-- Insert, Update and Delete Uniform Sub Category -->
<v-container v-if="tab === 'tab-1' && (lAction === 'create-subcat' || lAction === 'update-subcat')" class="pa-2" grid-list-md>
  <v-layout row wrap>
    <v-flex xs8 mx-auto>
      <v-form ref="lFormUniformSubCat" @submit.prevent="saveSubCatChanges(lAction)">
        <v-card>
          <v-card-title class="py-3 title">
            <div v-if="lAction === 'create-subcat'">
              Create Uniform Sub Category
            </div>
            <div v-else>
              Update Uniform Sub Category
            </div>
          </v-card-title>
          <v-card-text class="px-2 pb-2 pt-0">
            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field
                v-model="lUniformSubCat.uniform_sub_cat"
                label="Uniform Sub Category"
                :rules="[rules.required]"
                hide-details
                maxlength="100"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions class="pt-3">
            <v-layout row wrap>
              <v-spacer></v-spacer>
              <v-btn @click.stop="cancelChanges()">Cancel</v-btn>
              <v-btn v-if="lAction === 'update-subcat' && (config.IS_EDITED_BY_USER)" @click="deleteUniformSubCat(lUniformSubCat)">delete</v-btn>
              <v-btn type="submit" color="accent black--text" v-if="(config.IS_EDITED_BY_USER)" :disabled="beingSaved">Save</v-btn>
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-flex>
  </v-layout>
</v-container>

<!-- Insert, Update and Delete Uniform Category and Sub Category Mapping -->
<v-container v-if="tab === 'tab-2' && (lAction === 'create-catsubcatmap' || lAction === 'update-catsubcatmap')" class="pa-2" grid-list-md>
  <v-layout row wrap>
    <v-flex xs8 mx-auto>
      <v-form ref="lFormUniformCatSubCatMap" @submit.prevent="saveCatSubCatMapChanges(lAction)">
        <v-card>
          <v-card-title class="py-3 title">
            <div v-if="lAction === 'create-catsubcatmap'">
              Create Uniform Category &amp; Sub Category Mapping
            </div>
            <div v-else>
              Update Uniform Category &amp; Sub Category Mapping
            </div>
          </v-card-title>
          <v-card-text class="px-2 pb-2 pt-0">
            <v-layout row wrap>
              <v-flex xs12>
                <v-select
                v-model="luniformCatSubCatMap.uniform_cat_pair"
                :items="uniformCat"
                label="Uniform Category"
                item-text="uniform_cat"
                item-value="uniform_cat_id"
                hide-details
                return-object
                :rules="[rules.required]"
                ></v-select>
                <v-select
                v-model="luniformCatSubCatMap.uniform_sub_cat_pair"
                :items="uniformSubCat"
                label="Uniform Sub Category"
                item-text="uniform_sub_cat"
                item-value="uniform_sub_cat_id"
                hide-details
                return-object
                :rules="[rules.required]"
                ></v-select>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions class="pt-3">
            <v-layout row wrap>
              <v-spacer></v-spacer>
              <v-btn @click.stop="cancelChanges()">Cancel</v-btn>
              <v-btn v-if="lAction === 'update-catsubcatmap' && (config.IS_EDITED_BY_USER)" @click="deleteUniformCatSubCatMap(luniformCatSubCatMap)">delete</v-btn>
              <v-btn type="submit" color="accent black--text" v-if="(config.IS_EDITED_BY_USER)" :disabled="beingSaved">Save</v-btn>
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-flex>
  </v-layout>
</v-container>

<!-- Insert, Update and Delete Uniform sub Category and Size Mapping -->
<v-container v-if="tab === 'tab-3' && (lAction === 'create-subcatsizemap' || lAction === 'update-subcatsizemap')" class="pa-2" grid-list-md>
  <v-layout row wrap>
    <v-flex xs8 mx-auto>
      <v-form ref="lFormUniformSubCatSizeMap" @submit.prevent="saveSubCatSizeMapChanges(lAction)">
        <v-card>
          <v-card-title class="py-3 title">
            <div v-if="lAction === 'create-subcatsizemap'">
              Create Uniform Sub Category &amp; Size Mapping
            </div>
            <div v-else>
              Update Uniform Sub Category &amp; Size Mapping
            </div>
          </v-card-title>
          <v-card-text class="px-2 pb-2 pt-0">
            <v-layout row wrap>
              <v-flex xs12>
                <v-select
                v-model="luniformSubCatSizeMap.uniform_sub_cat_pair"
                :items="uniformSubCat"
                label="Uniform Sub Category"
                item-text="uniform_sub_cat"
                item-value="uniform_sub_cat_id"
                hide-details
                return-object
                :rules="[rules.required]"
                ></v-select>
              </v-flex>
              <v-flex xs12>
                <v-layout row wrap>
                  <v-flex xs11>
                    <v-select
                    v-model="luniformSubCatSizeMap.uniform_size_pair"
                    :items="uniformSize"
                    label="Uniform Size"
                    item-text="uniform_size"
                    item-value="uniform_size_id"
                    hide-details
                    return-object
                    :rules="[rules.required]"
                    ></v-select>
                  </v-flex>
                  <v-flex xs1 class="pt-3">
                    <v-btn
                    small fab fixed
                    @click="prepareUniformSize()">
                    <v-icon small>mdi-plus</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions class="pt-3">
          <v-layout row wrap>
            <v-spacer></v-spacer>
            <v-btn @click.stop="cancelChanges()">Cancel</v-btn>
            <v-btn v-if="lAction === 'update-subcatsizemap' && (config.IS_EDITED_BY_USER)" @click="deleteUniformSubCatSizeMap(luniformSubCatSizeMap)">delete</v-btn>
            <v-btn type="submit" color="accent black--text" v-if="(config.IS_EDITED_BY_USER)" :disabled="beingSaved">Save</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-flex>
</v-layout>
</v-container>

<!-- Manage Uniform Size -->
<v-dialog v-model="manageUniformSize" persistent max-width="300px">
  <v-form>
    <v-card flat v-if="lMAction === 'view'" scrollable>
      <v-card-title class="title grey lighten-4 py-0">
        Uniform Size
        <v-spacer></v-spacer>
        <v-btn small icon @click.stop="manageUniformSize = false"><v-icon>mdi-close</v-icon></v-btn>
      </v-card-title>
      <v-card-text class="pa-0">
        <v-flex xs12 sm9 md12 class="mx-auto">
          <v-spacer></v-spacer>
          <v-btn color="accent" text class="mb-0" style="float: right" @click="createUniformSize">Add New</v-btn>
          <v-data-table
          :headers="manageUniformSizeHead"
          :items="uniformSize"
          hide-default-footer
          :mobile-breakpoint="0"
          disable-pagination
          >
          <template slot="item" slot-scope="props">
            <tr @click="prepareUniformSizeEdit(props.item)">
              <td> {{ props.item.uniform_size ? props.item.uniform_size : '-' }} </td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-card-text>
  </v-card>

  <!-- Create, Edit and Delete Uniform Size -->
  <v-container v-if="lMAction === 'create' || lMAction === 'update'" class="pa-0" fluid grid-list-md>
    <v-form ref="sizeForm" @submit.prevent="saveUniformSize(lMAction)">
      <v-card flat class="pa-0">
        <v-card-title class="title pb-0">
          {{ handy.startWithUpper(lMAction) }} Uniform Size
        </v-card-title>
        <v-card-text>
          <v-text-field
          v-model="lUniformSize.uniform_size"
          label="Uniform Size"
          :rules="[rules.required]"
          hide-details
          maxlength="25">
        </v-text-field>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click.stop="cancelChangesUniformSize">Cancel</v-btn>
          <v-btn v-if="lMAction === 'update' && (config.IS_EDITED_BY_USER)" :disabled="beingSaved" @click="deleteUniformSize(lUniformSize)">delete</v-btn>
          <v-btn type="submit" color="accent" v-if="(config.IS_EDITED_BY_USER)" :disabled="beingSaved">Save</v-btn>
        </v-card-actions>
      </v-card-text>
    </v-card>
  </v-form>
</v-container>

</v-form>
</v-dialog>

</v-flex>

<!-- snack bar for reporting -->
<v-snackbar :color="sbarCol" v-model="sbar" :timeout="2500" multi-line>
  <span class="mx-auto">{{ sbarMsg }}</span>
</v-snackbar>

</v-layout>
</v-container>
</template>


<script>
import config from '@/config/app-cfg'
import handy from '@/utils/handy'

export default {
  data () {
    return {
      // Common Declarations
      lAction: '',
      handy: handy,
      config: config,
      sbarCol: '',
      sbarMsg: '',
      sbar: false,
      rules: handy.rules,
      tab: '',
      beingSaved: false,
      // Component Specific Declarations
      tabitems: ['Uniform Category', 'Uniform Sub Category', 'Category & Sub Category Mapping', 'Sub Category & Size Mapping'],
      // Uniform Category Declarations
      uniformCat: [],
      uniformCatHeader: [
        { text: 'Uniform Category Name', value: 'uniform_cat' },
        { text: 'Actions', value: '' }
      ],
      lUniformCat: [],
      // Uniform Sub Category Declarations
      uniformSubCat: [],
      uniformSubCatHeader: [
        { text: 'Uniform Sub Category Name', value: 'uniform_sub_cat' },
        { text: 'Actions', value: '' }
      ],
      lUniformSubCat: [],
      // Uniform Category and Sub Category Mapping Declarations
      uniformCatSubCatMap: [],
      uniformCatSubCatMapHeader: [
        { text: 'Uniform Category Name', value: 'uniform_cat' },
        { text: 'Uniform Sub Category Name', value: 'uniform_sub_cat' },
        { text: 'Actions', value: '' }
      ],
      luniformCatSubCatMap: [],
      // Uniform Sub Category and Size Mapping Declarations
      uniformSize: [],
      uniformSubCatSizeMap: [],
      uniformSubCatSizeMapHeader: [
        { text: 'Uniform Sub Category Name', value: 'uniform_sub_cat' },
        { text: 'Uniform Size Name', value: 'uniform_size' },
        { text: 'Actions', value: '' }
      ],
      luniformSubCatSizeMap: [],
      // Uniform Size Declarations
      manageUniformSize: false,
      lMAction: '',
      manageUniformSizeHead: [
        { text: 'Uniform Size', value: 'uniform_size' }
      ],
      lUniformSize: []
    }
  },
  created () {
    this.lAction = 'view'
    this.loadUniformCat()
    this.tab = 'tab-0'
  },
  methods: {
    // Common methods
    msg (m, type = 0) {
      if (type === 0) {
        this.sbarCol = 'error'
      } else if (type === 1) {
        this.sbarCol = 'success'
      } else {
        this.sbarCol = 'info'
      }
      this.sbar = true
      this.sbarMsg = m
    },
    cancelChanges () {
      this.lAction = 'view'
    },
    refreshTab (curTab) {
      if (curTab === 'Uniform Category') {
        this.loadUniformCat()
        this.tab = 'tab-0'
      } else if (curTab === 'Uniform Sub Category') {
        this.loadUniformSubCat()
        this.tab = 'tab-1'
      } else if (curTab === 'Category & Sub Category Mapping') {
        this.loadUniformSubCat()
        this.loadUniformCatSubCatMap()
        this.tab = 'tab-2'
      } else {
        this.loadUniformSubCat()
        this.loadUniformSize()
        this.loadUniformSubCatSizeMap()
        this.tab = 'tab-3'
      }
      this.lAction = 'view'
    },
    // Uniform Category Methods
    loadUniformCat () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getUniformCategory/', qry)
      .then(response => {
        this.uniformCat = response.data
      })
      .catch(err => {
        this.msg(err, true)
      })
    },
    prepareUniformCat () {
      this.lUniformCat = {
        uniform_cat: '',
        vendor_id: config.VENDOR_ID
      }
      this.lAction = 'create'
    },
    saveCatChanges (action) {
      if (this.$refs.lFormUniformCat.validate()) {
        var qry = {
          params: {
            uniform_cat: this.lUniformCat.uniform_cat,
            vendor_id: this.lUniformCat.vendor_id
          }
        }
        this.axios.get(config.API_URL + '/getUniformCategoryExists/', qry)
        .then(resp => {
          if (resp.data.length > 0) {
            this.msg('Uniform Category already exists with name "' + this.lUniformCat.uniform_cat + '"', 0)
          } else {
            this.axios.post(config.API_URL + '/uniformCategory/' + action, this.lUniformCat)
            .then(response => {
              setTimeout(() => {
                this.loadUniformCat()
              }, 500)
              this.msg('Saved Successfully', 1)
              this.beingSaved = false
              this.lAction = 'view'
            })
            .catch(err => {
              this.msg(err, 0)
              this.beingSaved = false
            })
          }
        })
      }
    },
    prepareUpdateUniformCat (curUniformCat) {
      this.lUniformCat = Object.assign({}, curUniformCat)
      this.lAction = 'update'
    },
    deleteUniformCat (curUniformCat) {
      if (!confirm('Sure, you want to delete the Uniform Category with name "' + curUniformCat.uniform_cat + '"')) {
        return
      }
      // Delete in db
      this.axios.post(config.API_URL + '/uniformCategory/delete', curUniformCat)
      .then (response => {
        this.loadUniformCat()
        this.lAction = 'view'
        this.msg('Uniform Category Deleted Successfully', 1)
        this.$forceUpdate()
      })
      .catch(err => {
        this.msg(err.response.data, 0)
        this.beingSaved = false
      })
    },
    // Uniform Sub Category Methods
    loadUniformSubCat () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getUniformSubCategory/', qry)
      .then(response => {
        this.uniformSubCat = response.data
      })
      .catch(err => {
        this.msg(err, true)
      })
    },
    prepareUniformSubCat () {
      this.lUniformSubCat = {
        uniform_sub_cat: '',
        vendor_id: config.VENDOR_ID
      }
      this.lAction = 'create-subcat'
    },
    prepareUpdateUniformSubCat (curUniformSubCat) {
      this.lUniformSubCat = Object.assign({}, curUniformSubCat)
      this.lAction = 'update-subcat'
    },
    saveSubCatChanges (action) {
      if (this.$refs.lFormUniformSubCat.validate()) {
        var qry = {
          params: {
            uniform_sub_cat: this.lUniformSubCat.uniform_sub_cat,
            vendor_id: this.lUniformSubCat.vendor_id
          }
        }
        this.axios.get(config.API_URL + '/getUniformSubCategoryExists/', qry)
        .then(resp => {
          if (resp.data.length > 0) {
            this.msg('Uniform Sub Category already exists with name "' + this.lUniformSubCat.uniform_sub_cat + '"', 0)
          } else {
            this.axios.post(config.API_URL + '/uniformSubCategory/' + action, this.lUniformSubCat)
            .then(response => {
              setTimeout(() => {
                this.loadUniformSubCat()
              }, 500)
              this.msg('Saved Successfully', 1)
              this.beingSaved = false
              this.lAction = 'view'
            })
            .catch(err => {
              this.msg(err, 0)
              this.beingSaved = false
            })
          }
        })
      }
    },
    deleteUniformSubCat (curUniformSubCat) {
      if (!confirm('Sure, you want to delete the Uniform Sub Category with name "' + curUniformSubCat.uniform_sub_cat + '"')) {
        return
      }
      // Delete in db
      this.axios.post(config.API_URL + '/uniformSubCategory/delete-subcat', curUniformSubCat)
      .then (response => {
        this.loadUniformSubCat()
        this.lAction = 'view'
        this.msg('Uniform Sub Category Deleted Successfully', 1)
        this.$forceUpdate()
      })
      .catch(err => {
        this.msg(err.response.data, 0)
        this.beingSaved = false
      })
    },
    // Uniform Category & Sub Category Mapping Methods
    loadUniformCatSubCatMap () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getUniformCatSubCatMap/', qry)
      .then(response => {
        this.uniformCatSubCatMap = response.data
      })
      .catch(err => {
        this.msg(err, true)
      })
    },
    prepareUniformCatSubCatMap () {
      this.luniformCatSubCatMap = {
        uniform_cat_pair: {},
        uniform_sub_cat_pair: {},
        vendor_id: config.VENDOR_ID
      }
      this.lAction = 'create-catsubcatmap'
    },
    prepareUpdateUniformCatSubCatMap (curUniformCatSubCatMap) {
      this.luniformCatSubCatMap = Object.assign({}, curUniformCatSubCatMap)
      this.luniformCatSubCatMap.uniform_cat_pair = { uniform_cat: curUniformCatSubCatMap.uniform_cat, uniform_cat_id: curUniformCatSubCatMap.uniform_cat_id}
      this.luniformCatSubCatMap.uniform_sub_cat_pair = { uniform_sub_cat: curUniformCatSubCatMap.uniform_sub_cat, uniform_sub_cat_id: curUniformCatSubCatMap.uniform_sub_cat_id}
      this.luniformCatSubCatMap.old_uniform_cat_id = curUniformCatSubCatMap.uniform_cat_id
      this.luniformCatSubCatMap.old_uniform_sub_cat_id = curUniformCatSubCatMap.uniform_sub_cat_id
      this.lAction = 'update-catsubcatmap'
    },
    saveCatSubCatMapChanges (action) {
      if (this.$refs.lFormUniformCatSubCatMap.validate()) {
        if (this.luniformCatSubCatMap.uniform_cat_pair.uniform_cat_id && this.luniformCatSubCatMap.uniform_sub_cat_pair.uniform_sub_cat_id) {
        var qry = {
          params: {
            uniform_cat_id: this.luniformCatSubCatMap.uniform_cat_pair.uniform_cat_id,
            uniform_sub_cat_id: this.luniformCatSubCatMap.uniform_sub_cat_pair.uniform_sub_cat_id,
            vendor_id: this.luniformCatSubCatMap.vendor_id
          }
        }
        this.axios.get(config.API_URL + '/getUniformCatSubCatMapExists/', qry)
        .then(resp => {
          if (resp.data.length > 0) {
            this.msg('Mapping of Uniform Category and Sub Category already exists : "' + this.luniformCatSubCatMap.uniform_cat_pair.uniform_cat + ' -> ' + this.luniformCatSubCatMap.uniform_sub_cat_pair.uniform_sub_cat + '"', 0)
          } else {
            this.axios.post(config.API_URL + '/uniformCatSubCatMap/' + action, this.luniformCatSubCatMap)
            .then(response => {
              setTimeout(() => {
                this.loadUniformCatSubCatMap()
              }, 500)
              this.msg('Saved Successfully', 1)
              this.beingSaved = false
              this.lAction = 'view'
            })
            .catch(err => {
              this.msg(err, 0)
              this.beingSaved = false
            })
          }
        })
      } else {
        this.msg('Please enter all mandatory field', 0)
      }
      }
    },
    deleteUniformCatSubCatMap (curUniformCatSubCatMap) {
      if (!confirm('Sure, you want to delete the Uniform Category and Sub Category Mapping')) {
        return
      }
      // Delete in db
      this.axios.post(config.API_URL + '/uniformCatSubCatMap/delete-catsubcatmap', curUniformCatSubCatMap)
      .then (response => {
        this.loadUniformCatSubCatMap()
        this.lAction = 'view'
        this.msg('Uniform Category and Sub Category Mapping Deleted Successfully', 1)
        this.$forceUpdate()
      })
      .catch(err => {
        this.msg(err, 0)
        this.beingSaved = false
      })
    },
    // Uniform Sub Category & Size Mapping Methods
    loadUniformSubCatSizeMap () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getUniformSubCatSizeMap/', qry)
      .then(response => {
        this.uniformSubCatSizeMap = response.data
      })
      .catch(err => {
        this.msg(err, true)
      })
    },
    loadUniformSize () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getUniformSize/', qry)
      .then(response => {
        this.uniformSize = response.data
      })
      .catch(err => {
        this.msg(err, true)
      })
    },
    prepareUniformSubCatSizeMap () {
      this.luniformSubCatSizeMap = {
        uniform_sub_cat_pair: {},
        uniform_size_pair: {},
        vendor_id: config.VENDOR_ID
      }
      this.lAction = 'create-subcatsizemap'
    },
    prepareUpdateUniformSubCatSizeMap (curUniformSubCatSizeMap) {
      this.luniformSubCatSizeMap = Object.assign({}, curUniformSubCatSizeMap)
      this.luniformSubCatSizeMap.uniform_sub_cat_pair = { uniform_sub_cat: curUniformSubCatSizeMap.uniform_sub_cat, uniform_sub_cat_id: curUniformSubCatSizeMap.uniform_sub_cat_id}
      this.luniformSubCatSizeMap.uniform_size_pair = { uniform_size: curUniformSubCatSizeMap.uniform_size, uniform_size_id: curUniformSubCatSizeMap.uniform_size_id}
      this.luniformSubCatSizeMap.old_uniform_sub_cat_id = curUniformSubCatSizeMap.uniform_sub_cat_id
      this.luniformSubCatSizeMap.old_uniform_size_id = curUniformSubCatSizeMap.uniform_size_id
      this.lAction = 'update-subcatsizemap'
    },
    saveSubCatSizeMapChanges (action) {
      if (this.$refs.lFormUniformSubCatSizeMap.validate()) {
        if (this.luniformSubCatSizeMap.uniform_sub_cat_pair.uniform_sub_cat_id && this.luniformSubCatSizeMap.uniform_size_pair.uniform_size_id) {
        var qry = {
          params: {
            uniform_sub_cat_id: this.luniformSubCatSizeMap.uniform_sub_cat_pair.uniform_sub_cat_id,
            uniform_size_id: this.luniformSubCatSizeMap.uniform_size_pair.uniform_size_id,
            vendor_id: this.luniformSubCatSizeMap.vendor_id
          }
        }
        this.axios.get(config.API_URL + '/getUniformSubCatSizeMapExists/', qry)
        .then(resp => {
          if (resp.data.length > 0) {
            this.msg('Mapping of Uniform Sub Category and Size already exists : "' + this.luniformSubCatSizeMap.uniform_sub_cat_pair.uniform_sub_cat + ' -> ' + this.luniformSubCatSizeMap.uniform_size_pair.uniform_size + '"', 0)
          } else {
            this.axios.post(config.API_URL + '/uniformSubCatSizeMap/' + action, this.luniformSubCatSizeMap)
            .then(response => {
              setTimeout(() => {
                this.loadUniformSubCatSizeMap()
              }, 500)
              this.msg('Saved Successfully', 1)
              this.beingSaved = false
              this.lAction = 'view'
            })
            .catch(err => {
              this.msg(err, 0)
              this.beingSaved = false
            })
          }
        })
      } else {
        this.msg('Please enter all mandatory field', 0)
      }
      }
    },
    deleteUniformSubCatSizeMap (curUniformSubCatSizeMap) {
      if (!confirm('Sure, you want to delete the Uniform Sub Category and Size Mapping')) {
        return
      }
      // Delete in db
      this.axios.post(config.API_URL + '/uniformSubCatSizeMap/delete-subcatsizemap', curUniformSubCatSizeMap)
      .then (response => {
        this.loadUniformSubCatSizeMap()
        this.lAction = 'view'
        this.msg('Uniform Sub Category and Size Mapping Deleted Successfully', 1)
        this.$forceUpdate()
      })
      .catch(err => {
        this.msg(err, 0)
        this.beingSaved = false
      })
    },
    // Uniform Size Methods
    prepareUniformSize () {
      this.manageUniformSize = true
      this.lMAction = 'view'
    },
    createUniformSize () {
      this.lUniformSize = {
        vendor_id: config.VENDOR_ID,
        uniform_size: ''
      }
      this.lMAction = 'create'
    },
    prepareUniformSizeEdit (curUniformSize) {
      this.lUniformSize = Object.assign({}, curUniformSize) // keep the original object safely before changes
      this.lMAction = 'update'
    },
    saveUniformSize (action) {
      // validate and save Changes
      if (this.$refs.sizeForm.validate()) {
        var qry = {
          params: {
            uniform_size: this.lUniformSize.uniform_size,
            vendor_id: this.lUniformSize.vendor_id
          }
        }
        this.axios.get(config.API_URL + '/getUniformSizeExists/', qry)
        .then(resp => {
          if (resp.data.length > 0) {
            this.msg('Uniform Size already exists : "' + this.lUniformSize.uniform_size + '"', 0)
          } else {
            this.beingSaved = true
            this.axios.post(config.API_URL + '/uniformSize/' + action, this.lUniformSize)
            .then(response => {
              // refresh the Uniform Size list
              this.loadUniformSize()
              this.lMAction = 'view'
              this.beingSaved = false
            })
            .catch(err => {
              this.msg(err.response.data)
              this.beingSaved = false
            })
          }
        })
      }
    },
    cancelChangesUniformSize () {
      this.lMAction = 'view'
    },
    deleteUniformSize (curUniformSize) {
      if (!confirm('Sure, you want to delete the Uniform Size "' + curUniformSize.uniform_size + '"?')) {
        return
      }
      this.beingSaved = true
      this.axios.post(config.API_URL + '/uniformSize/delete', curUniformSize)
      .then(response => {
        // refresh the Uniform Size list
        this.loadUniformSize()
        this.lMAction = 'view'
        this.beingSaved = false
      })
      .catch(err => {
        this.msg(err.response.data)
        this.beingSaved = false
      })
    }
  }
}

</script>
